import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconChevronLeft = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 9,
	height: 16,
	viewBox: "0 0 9 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8 15L0.999999 8L8 1",
		stroke: "black",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgIconChevronLeft;
